export default __webpack_public_path__ + "static/media/SubscribedSuccess.7337ff5b.png";